import DatePicker from 'react-datepicker';
import styled, { css } from 'styled-components';

export const DatePickerStyled = styled(DatePicker)`
  ${({ theme, error }) => css`
    border: 1px solid ${error ? theme.colors.dangerBtn : 'inherit'} !important;

    &:focus,
    &:hover {
      border: 1px solid ${error ? theme.colors.dangerBtn : 'inherit'} !important;
    }
  `};
`;
